__turbopack_context__.v({
  "container": "index-module-scss-module__nAyq6G__container",
  "footer": "index-module-scss-module__nAyq6G__footer",
});
